import styled from 'styled-components';
import { ScreenScrapeLoader } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeLoader';
import { useCountdown } from 'src/pages/AspspSelectPage/ScreenScrape/ScreenScrapeAuthorize/useCountdown';
import { ScreenScrapeStepTitle } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeStepTitle';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';
import { useEffect } from 'react';
import { MessageCode } from 'src/common/models/message';

const Text = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.text.secondary};
`;

const authorizationTime = 120;

export const ScreenScrapeAuthorize = () => {
  const { minutesToDisplay, secondsToDisplay, reset } =
    useCountdown(authorizationTime);
  const ctx = useSSContext();

  useEffect(() => {
    if (
      ctx.lastJsonMessage?.messageCode ===
      MessageCode.RetryAuthorizeOperationPush
    ) {
      reset();
    }
  }, [ctx.lastJsonMessage]);

  return (
    <>
      <ScreenScrapeStepTitle>
        {ctx.lastJsonMessage?.value}
      </ScreenScrapeStepTitle>
      <ScreenScrapeLoader text="Oczekiwanie na akceptację" />
      <Text>
        Czas na akceptację autoryzacji:{' '}
        {`${minutesToDisplay}:${secondsToDisplay}`}
      </Text>
    </>
  );
};
